import { handleApiError } from '@/handleApiError'
import orderApi from '@/modules/order/api'
import productApi from '@/modules/product/api'
import { InstantSearchItem, InstantSearchType } from '@/modules/search/type'
import { t } from '@/plugins/i18n.ts'
import { MediumProduct, OrderSearchModel } from '@/types/index'
import { defineStore } from 'pinia'

interface InstantSearchState {
  instantSearchItems: {
    products: MediumProduct[]
    orders: OrderSearchModel[]
  }
  loading: boolean
}

const initialState = (): InstantSearchState => {
  return {
    instantSearchItems: {
      products: [],
      orders: []
    },
    loading: false
  }
}

const useInstantSearch = defineStore('instantSearch', {
  state: () => initialState(),
  getters: {
    getInstantSearchItems: (state) => {
      let items: InstantSearchItem[] = []

      if (state.instantSearchItems.products.length > 0) {
        items.push({ text: t('products'), type: InstantSearchType.PRODUCT })
        items = items.concat(state.instantSearchItems.products)
      }

      if (state.instantSearchItems.orders.length > 0) {
        items.push({ text: t('order.orders'), type: InstantSearchType.ORDER })
        items = items.concat(state.instantSearchItems.orders)
      }

      return items
    }
  },
  actions: {
    async instantSearch(searchTerm: string) {
      this.loading = true

      const searchProducts = productApi
        .searchProducts({ keyword: searchTerm, instantSearch: true, size: 5 }, 0)
        .then(({ data }) => {
          this.instantSearchItems.products = data.items
        })

      const searchOrders = orderApi.searchOrders(searchTerm).then(({ data }) => {
        this.instantSearchItems.orders = data
      })

      return Promise.all([searchProducts, searchOrders])
        .catch(handleApiError)
        .finally(() => {
          this.loading = false
        })
    },
    clearItems() {
      this.instantSearchItems.products = []
      this.instantSearchItems.orders = []
    }
  }
})

export default useInstantSearch
